import React, { Fragment, useEffect, useState } from "react";

import { Line, List, Text } from "components";
import { FormInput } from "components/FormInput";
import Footer1 from "components/Footer1";
import InfoRibbon from "components/InfoRibbon";
import Header from "../../components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { cartChanges, getAllCarts, totalAmountInCarts, totalItemsInCarts } from "../../states/cart.mjs";
import { formatCurrency } from "../../helpers/number";
import { CartPreviewItem } from "../../components/CartPreviewItem";
import { scrollToTop } from "../../helpers/scroll";
import { clearSearchKeyword } from "../../states/search.mjs";
import { QuotationOptions } from "../../components/QuotationOptions";

const CartCheckoutPaymentPagePage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  // const [orderStatus, setOrderStatus] = useState(Order_Status.NOT_PAID);
  // const [pendingOrder, setPendingOrder] = useState();
  // const [batchId, setBatchId] = useState(() => v4());
  // const [cartBatchId, setCartBatchId] = useState(() => v4());
  // const [formData, setFormData] = useState({ mobile: "" });
  // const [errors, setErrors] = useState();
  const [carts, setCarts] = useState([]);
  const [totalCartAmount, setTotalCartAmount] = useState(0);
  const [totalCartItems, setTotalCartItems] = useState(0);

  useEffect(() => {
    const subscription = cartChanges(() => {
      setCarts(getAllCarts());
      setTotalCartAmount(totalAmountInCarts());
      setTotalCartItems(totalItemsInCarts());
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (totalItemsInCarts() < 1) {
      navigate("/productspage");
    }
  }, [navigate]);

  useEffect(() => {
    scrollToTop();
    return () => {
      clearSearchKeyword();
    };
  }, []);

  // const paymentSubmit = useMemo(() => {
  //   return () => {
  //     const { fullname, email, mobile, notes, region } = state ?? {};
  //     const req = {
  //       path: {
  //         pid: "c6d12f0c-7e49-449b-b5e4-98713408de66",
  //         aid: "99b487f4-04d6-451d-b977-dca884d4f074"
  //       },
  //       data: {
  //         carts: justArray(carts).map(({ quantity, product }, index) => ({
  //           quantity,
  //           unit_price: product?.retailPrice,
  //           product: product?.product,
  //           description: product?.description,
  //           images: product?.images,
  //           batch: cartBatchId + "_" + index + 1
  //         })),
  //         payment_mode: "tigopesa_push",
  //         payment_reference: formData?.mobile,
  //         shipping: { fullname, email, mobile, notes, region },
  //         batch: batchId
  //       }
  //     };
  //     startLoading();
  //     submitOrder(req).then((res) => {
  //       if (res?.data?.paid === true) {
  //         setPendingOrder({ id: res?.data?.id, paid: true, processed: true, completed: false });
  //         setOrderStatus(Order_Status.PAID);
  //         clearCart();
  //         navigate("/ordersviewpage", {
  //           state: { _mobile: formData?.mobile }
  //         });
  //       } else {
  //         console.log(res?.data);
  //         setPendingOrder({ id: res?.data?.id, paid: false, processed: false, completed: false });
  //         setOrderStatus(Order_Status.PENDING);
  //       }
  //     }).catch((err) => {
  //       console.error(err);
  //       toast.error("Fail to submit your order");
  //     }).finally(() => {
  //       stopLoading();
  //     });
  //   };
  // }, [batchId, cartBatchId, carts, formData?.mobile, state]);

  // const validateFormData = useMemo(() => {
  //   return () => {
  //     let hasError = false;
  //     Object.keys(formData).forEach(x => {
  //       if (!formData[x] || formData[x] === "") {
  //         hasError = true;
  //         setErrors(p => ({ ...p, [x]: ["Field required"] }));
  //       }
  //     });
  //     if (hasError) {
  //       toast.error("Please fill required fields");
  //       scrollToTop(90);
  //     } else {
  //       paymentSubmit();
  //     }
  //   };
  // }, [formData, paymentSubmit]);

  return (
    <>
      <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
        <div className="flex flex-col items-center justify-start w-full">
          <InfoRibbon className="bg-deep_purple-900 flex flex-row md:gap-10 items-center justify-between p-3 w-full" />
          <Header showSearch={false} />
          <div className="flex md:flex-col mb-16 flex-row gap-5 items-start justify-start mt-[58px] px-8 w-full">
            <QuotationOptions amount={totalCartAmount} shipping={state} carts={carts} />
            {/*{*/}
            {/*  orderStatus === Order_Status.NOT_PAID && <PaymentOptions*/}
            {/*    errors={errors}*/}
            {/*    formData={formData}*/}
            {/*    setErrors={setErrors}*/}
            {/*    setFormData={setFormData}*/}
            {/*    validateFormData={validateFormData} />*/}
            {/*}*/}
            {/*{*/}
            {/*  orderStatus === Order_Status.PAID &&*/}
            {/*  <OrderPaidWidget order={pendingOrder?.paid === true ? { ...state, ...pendingOrder } : state} />*/}
            {/*}*/}
            {/*{*/}
            {/*  orderStatus === Order_Status.PENDING &&*/}
            {/*  <PendingPaymentWidget autoRetry={paymentSubmit} order={pendingOrder} />*/}
            {/*}*/}
            <div
              className="bg-white-A700 border sticky top-[120px] flex md:flex-1 flex-col items-center justify-start p-[15px] rounded-lg w-[33%] md:w-full">
              <div className="flex flex-col gap-[18px] items-start justify-start w-full">
                <Text
                  className="text-black-900_dd text-xl tracking-[0.15px]"
                  size="txtInterRegular20"
                >
                  Total ( {totalCartItems} Items )
                </Text>
                <div className="flex flex-col items-center justify-start w-[78%] md:w-full">
                  <div className="flex flex-row gap-3 items-start justify-start w-full">
                    <Text
                      className="text-blue_gray-700 text-xs tracking-[0.40px]"
                      size="txtInterRegular12"
                    >
                      TZS
                    </Text>
                    <Text
                      className="text-black-900_dd text-xl tracking-[0.15px]"
                      size="txtInterMedium20"
                    >
                      {formatCurrency(totalCartAmount)}
                    </Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Text className="text-base text-gray-700 self-start px-8">Items</Text>
          {
            carts.length > 0 && <>
              <div className="flex flex-col gap-5 items-start justify-between mt-7 mx-auto px-8 w-full">
                <div
                  className="bg-white-A700 border flex md:flex-1 flex-col items-center justify-start p-[21px] sm:px-5 rounded-lg w-full">
                  <List
                    className="flex flex-col gap-8 items-center mt-[21px] w-full"
                    orientation="vertical"
                  >
                    {
                      carts?.map((cart, index) => {
                        return (
                          <Fragment key={cart?.product?.id ?? index}>
                            <CartPreviewItem
                              quantity={cart?.quantity}
                              product={cart?.product}
                              image={cart?.product?.images[0]}
                              amount={cart?.product?.retailPrice}
                              name={cart?.product?.product}
                              description={cart?.product?.description} />
                            {(index + 1) !== carts.length && <Line className="bg-gray-300 mb-8 h-px  mx-auto w-full" />}
                          </Fragment>
                        );
                      })
                    }
                  </List>
                </div>
                <div className="bg-white-A700 mt-8 flex md:flex-1 flex-col items-center justify-start rounded-lg w-full">
                  <div className="flex flex-col gap-[18px] items-start justify-start w-full">
                    <Text className="mb-3 text-base">Shipping </Text>
                    <div className="w-full flex gap-4 flex-row sm:flex-col">
                      <FormInput label="Full name" className="w-full" value={state?.fullname} />
                      <FormInput label="Email" className="w-full" value={state?.email} />
                    </div>
                    <div className="w-full flex gap-4 flex-row sm:flex-col">
                      <FormInput label="Mobile" className="w-full" value={state?.mobile} />
                      <FormInput label="Region" className="w-full" value={state?.region} />
                    </div>
                    <FormInput label="Notes" lines={3} className="w-full" value={state?.notes} />
                  </div>
                </div>
              </div>
            </>
          }
          <Footer1 className="bg-blue_gray-900 flex items-center justify-center mt-[104px] md:px-5 w-full" />
        </div>
      </div>
    </>
  );
};

export default CartCheckoutPaymentPagePage;
